import { Skeleton } from "@facade/components/ui";

export const ProjectTabContentSkeleton = () => {
  return (
    <div className="grid grid-cols-12 gap-4 opacity-25 w-full">
      <Skeleton className="col-span-12  rounded-lg lg:col-span-7" />
      <Skeleton className="col-span-12  rounded-lg lg:col-span-5" />

      <Skeleton className="col-span-12 rounded-lg lg:col-span-4" />
      <Skeleton className="col-span-12  rounded-lg lg:col-span-8" />

      <Skeleton className="col-span-12 rounded-lg" />
    </div>
  );
};
